import Footer from "./Footer";
import Header from "./Header";
import { useTranslation } from 'react-i18next';
import styled from "styled-components"

const LawSide = () => {
    const { t } = useTranslation();

    return (
        <PageWrapper>
            <Header />
            <Container>
            <Title> <strong>{t('Law.Title')}</strong></Title>
            <Paragraph>{t('t&c.Update')}</Paragraph>
                <Paragraph><strong>{t('Law.par1STRONG')}</strong>{t('Law.par1')}</Paragraph>
                <Paragraph>{t('Law.par2')}</Paragraph>
                <Paragraph>{t('Law.par3')}</Paragraph>
        
            <Title>{t('footer.t&c')}</Title>

                <Subtitle>{t('Law.Sub1')}</Subtitle>

                <Paragraph>{t('Law.liv1')}</Paragraph>
                <Paragraph>{t('Law.liv1')}</Paragraph>
                <Paragraph>{t('Law.liv3')}</Paragraph>
                <Paragraph>{t('Law.liv4')}</Paragraph>
                <Paragraph>{t('Law.liv5')}</Paragraph>
                

                <Subtitle>{t('Law.Sub2')}</Subtitle>

                <Paragraph>{t('Law.Uti1')}</Paragraph>
                <Paragraph>{t('Law.Uti2')} " {t('Law.Uti2aussi')}</Paragraph>
                <Paragraph>{t('Law.Uti3')}</Paragraph>

                <Subtitle>{t('Law.Sub3')}</Subtitle>
                <Paragraph>{t('Law.reg1')} " {t('Law.reg1aussi1')} ", " {t('Law.reg1aussi2')} ", " {t('Law.reg1aussi3')} ", " {t('Law.reg1aussi4')} " {t('Law.reg1aussi5')} " {t('Law.reg1aussi6')} " {t('Law.reg1continue')}</Paragraph>
                <Paragraph>{t('Law.reg2')}</Paragraph>

                <Subtitle>{t('Law.Sub4')}</Subtitle>
                <Paragraph>{t('Law.Coop')}</Paragraph>

                <Subtitle>{t('Law.Sub5')}</Subtitle>
                <Paragraph>{t('Law.con1')}</Paragraph>
                <Paragraph>{t('Law.con2')}</Paragraph>

                <Subtitle>{t('Law.Sub6')}</Subtitle>
                <Paragraph><strong>{t('Law.avSTRONG1')}</strong> {t('Law.av')} <strong> {t('Law.avSTRONG2')} </strong>"<strong>{t('Law.avSTRONG3')}</strong>" <strong>{t('Law.avSTRONG4')}</strong>{t('Law.av2')}
                <strong> {t('Law.avSTRONG5')}</strong> {t('Law.av3')} <strong> {t('Law.avSTRONG6')} </strong>
                {t('Law.av4')} <strong>{t('Law.avSTRONG7')}</strong> {t('Law.av5')} <strong>{t('Law.avSTRONG8')}</strong>
                </Paragraph>
                <Paragraph>{t('Law.avpar2')}</Paragraph>
                <Paragraph>{t('Law.avpar3')}</Paragraph>
                <Paragraph>{t('Law.avpar4')}</Paragraph>
                

                <Subtitle>{t('Law.Sub7')}</Subtitle>
                <Paragraph>{t('Law.Aut')} <strong>{t('Law.AutSTRONG')}</strong></Paragraph>

                <Title>{t('footer.pp')}</Title>
                
                <Paragraph>{t('Law.PPSub')}</Paragraph>

                <Subtitle>{t('Law.PPSub2')}</Subtitle>
                <Paragraph>{t('Law.Int')}</Paragraph>

                <Subtitle>{t('Law.PPSub3')}</Subtitle>
                <Paragraph>{t('Law.Ret1')}</Paragraph>
                <Paragraph><strong>{t('Law.RetSTRONG2')} </strong>{t('Law.Ret2')}</Paragraph>
                <Paragraph><strong>{t('Law.RetSTRONG3')} </strong>{t('Law.Ret3')}</Paragraph>
                <Paragraph><strong>{t('Law.RetSTRONG4')} </strong>{t('Law.Ret4')}</Paragraph>
                <Paragraph><strong>{t('Law.RetSTRONG5')} </strong>{t('Law.Ret5')} <strong>{t('Law.RetSTRONG5after')}</strong></Paragraph>
                <Paragraph><strong>{t('Law.RetSTRONG6')} </strong>{t('Law.Ret6')}</Paragraph>
                <Paragraph><strong>{t('Law.RetSTRONG7')} </strong>{t('Law.Ret7')}</Paragraph>
                <Paragraph><strong>{t('Law.RetSTRONG8')} </strong>{t('Law.Ret8')}</Paragraph>
                <Paragraph>{t('Law.Ret9')}</Paragraph>

                <Subtitle>{t('Law.PPSub4')}</Subtitle>
                <Paragraph><strong>{t('Law.LimitSTRONG1')}</strong> {t('Law.Limit1')} <strong>{t('Law.LimitSTRONG2')}</strong> " 
                <strong> {t('Law.LimitSTRONG3')} </strong>{t('Law.Limit2')} 
                <strong>{t('Law.LimitSTRONG4')} </strong>{t('Law.Limit3')} <strong>{t('Law.LimitSTRONG5')}</strong> {t('Law.Limit4')} 
                <strong> {t('Law.LimitSTRONG6')} </strong>
                {t('Law.Limit5')} <strong>{t('Law.LimitSTRONG7')}</strong> {t('Law.Limit6')} <strong>{t('Law.LimitSTRONG8')}</strong> {t('Law.Limit7')} 
                <strong>{t('Law.LimitSTRONG9')}</strong>
                </Paragraph>
                <Paragraph>{t('Law.Limitpar2')} <strong>{t('Law.Limitpar2STRONG')}</strong></Paragraph>
                <Paragraph><strong>{t('Law.Limitpar3STRONG')} </strong>{t('Law.Limitpar3')} <strong>{t('Law.Limitpar3STRONG2')}</strong></Paragraph>

                <Subtitle>{t('Law.PPSub5')}</Subtitle>
                <Paragraph>{t('Law.Reso1')} </Paragraph>
                <Paragraph>{t('Law.Reso2')}</Paragraph>

                <Subtitle>{t('Law.PPSub6')}</Subtitle>
                <Paragraph>{t('Law.Amen')}</Paragraph>

                <Subtitle>{t('Law.PPSub7')}</Subtitle>
                <Paragraph>{t('Law.Ren1')} " {t('Law.Renmid')} " {t('Law.Ren1after')} 
                <strong>{t('Law.RenSTRONG1')} </strong>{t('Law.Ren2')} <strong>{t('Law.RenSTRONG2')}</strong>{t('Law.Ren3')} <strong>{t('Law.RenSTRONG3')}</strong>
                </Paragraph>

                <Subtitle>{t('Law.PPSub8')}</Subtitle>
                <Paragraph><strong>{t('Law.CookSTRONG1')}</strong></Paragraph>
                <Paragraph>{t('Law.Cook1')}</Paragraph>
                <Paragraph>{t('Law.Cook2')}</Paragraph>
                <Paragraph>{t('Law.Cook3')}</Paragraph>

                <Paragraph>{t('Law.Cook4')}</Paragraph>
            </Container>
            <Footer />
        </PageWrapper>
    );
};

export default LawSide;

const PageWrapper = styled.div`
    
    background:linear-gradient(122deg, rgba(148,163,135,1) 0%, rgba(186,204,171,1) 43%, rgba(246,187,155,1) 83%, rgba(217,121,97,1) 100%);
    color: #1a1a1a;
`;

const Container = styled.main`
    padding: 60px 20px;
    max-width: 960px;
    margin: auto;
    background-color: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border-radius: 8px;

    @media (max-width: 768px) {
        padding: 40px 15px;
    }
`;

const Title = styled.h1`
    font-size: 2.5rem;
    font-weight: 600;
    color:rgb(4, 88, 39);
    margin-bottom: 20px;
`;

const Subtitle = styled.h3`
    font-size: 1.75rem;
    font-weight: 500;
    color:rgb(4, 88, 39);
    margin-top: 40px;
    margin-bottom: 15px;
`;

const Paragraph = styled.p`
    
    font-size: 1rem;
    line-height: 1.7;
    margin-bottom: 20px;
`;